module.exports = __webpack_public_path__ + "static/img/sua-jonathan.2fd5a0a.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/sua-jonathan.jpg
// module id = Crvx
// module chunks = 0